<!--suppress ALL -->

<template>
	<tr>
		<td class="text-center">
			{{ type.name }}
		</td>
		<td class="text-center">
			{{ type.open_question }}
		</td>
		<td class="text-center">
			{{ type.close_question }}
		</td>
		<td class="text-center">
			{{ type.yes_no_question }}
		</td>
		<td class="text-center">
			{{ type.json_path }}
		</td>
		<td>
			<edit-btn
				class="mx-2 my-1"
				@click="onEdit"
			/>
			<remove-btn
				class="mx-2 my-1"
				@remove="doRemove"
			/>
		</td>
	</tr>
</template>

<script>

import { types } from "src/store/modules/Type.module";
import RemoveBtn from "src/scaffoldings/RemoveBtn";
import EditBtn from "src/scaffoldings/EditBtn";
import RowMixin from "src/mixins/RowMixin";

export default {
	name: "TypeRow",
	components: { EditBtn, RemoveBtn },
	props: {
		type: { required: true },
	},
	mixins: [new RowMixin(types, "type")],
	data () {
		return {};
	},
	computed: {},
	methods: {
		doRemove () {
			this.$store.dispatch(types.REMOVE, this.type).then(() => {
			});
		},
		onEdit () {
			this.$emit("edit", this.type);
		},
	},
};
</script>

<style>

</style>
